import { connect } from 'react-redux';
import React, {  useState } from "react";
import addDays from "date-fns/addDays";
import { useLocation, useParams } from 'react-router';
import Button from 'react-bootstrap/Button';



function useQuery() {
    return new URLSearchParams(useLocation().search);
}








const EditReservation = () => {
    let query = useQuery();

    const [address, setAddress] = useState("");
    const [hideLogin, setHideLogin] = useState(false);

    const [name, setName] = useState("");
    const [state, setState] = useState("");
    const [phone, setPhone] = useState("");
    const [title, setTitle] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [regno, setRegno] = useState("");
    const [account, setAccount] = useState("");
    const [price, setPrice] = useState("");
    const [paid, setPaid] = useState("");
    const [depositBalance, setDepositBalance] = useState("");

    const [locked, setLocked] = useState(false);
    var [reservationData, setReservationData] = useState([{ "id": 0, "name": "", "date": "", "phone": "", "title": "", "price": 0, "paid": 0, "depositBalance": 0, "consumption": 0, "email": "", "address": "", "reservationdate": "", "account": "", "regno": "", "eventType": "" , "state":""}]);


    async function fetchReservation() {
        const response = await fetch('UserEdit?action=fetch&id=' + query.get("id") + "&address=" + address);
        const data = await response.json();
        setName(data[0].name);
        setPhone(data[0].phone);
        setTitle(data[0].title);
        setEmail(data[0].email);
        setDate(data[0].date);
        setAccount(data[0].account);
        setRegno(data[0].regno);
        setPrice(data[0].price);
        setPaid(data[0].paid);
        setDepositBalance(data[0].depositBalance);

        if (data[0].state == "Cancelled") {
            setState("Aflyst");
            setLocked(true);
        } else if (data[0].state == "Archived") {
            setState("Afsluttet");
            setLocked(true);
        } else {
            setState("Aktiv");
        }
        
        setHideLogin(true);
    }

    async function cancelReservation() {
        await fetch('UserEdit?action=cancel&id=' + query.get("id") + "&address=" + address + "&state=Cancelled");
        
        setState("Aflyst");
        setLocked(true);
        { /* TODO : Reload/reset Page */}
        
    }

    
    async function updateReservation() {
        await fetch('UserEdit?action=update&id=' + query.get("id") + "&address=" + address + "&state=Updated" + "&name=" + name + "&phone=" + phone + "&title=" + title + "&email=" + email);

        setHideLogin(false);
    }

    return (
        <div>
            
            <h1>Rediger reservation</h1>
            <br/>
            <table width="40%">
                {/* "logon" View */}
                <tr>
                    <td>Adresse</td>
                    <td><input type="text" placeholder="Din adresse" value={address} onChange={e => setAddress(e.target.value)} disabled={locked || hideLogin} /></td>
                </tr>
                {/* Edit View */}
                <tr hidden={!hideLogin}>
                    <td>Reserveret af:</td>
                    <td><input type="text" onChange={e => setName(e.target.value)} value={name} disabled={locked}></input></td>
                </tr>
                <tr hidden={!hideLogin}>
                    <td>Telefon nr:</td>
                    <td><input type="text" onChange={e => setPhone(e.target.value)} value={phone} disabled={locked}></input></td>
                </tr>
                <tr hidden={!hideLogin}>
                    <td>Arrangementets titel:</td>
                    <td><input type="text" onChange={e => setTitle(e.target.value)} value={title} disabled={locked}></input></td>
                </tr>
                <tr hidden={!hideLogin}>
                    <td>eMail:</td>
                    <td><input type="text" onChange={e => setEmail(e.target.value)} value={email} disabled={locked}></input></td>
                </tr>

                <br />
                <tr hidden={!hideLogin}>
                    <td>Dato for arrangementet:</td>
                    <td>{date}</td>
                </tr>

                <tr hidden={!hideLogin}>
                    <td>Registreret betaling :</td>
                    <td>{paid + ' af ' + price + ' kr'}</td>
                </tr>
                <tr hidden={!hideLogin}>
                    <td>Indestående depositum :</td>
                    <td>{depositBalance + ' kr'}</td>
                </tr>
                
                <tr hidden={!hideLogin}>
                    <td>Konto oplysninger:</td>
                    <td>{regno + ' - ' + account}</td>
                </tr>
                <tr hidden={!hideLogin}>
                    <td>Reservationens status:</td>
                    <td>{state}</td>
                </tr>
            </table>
            

                <br />
            <Button hidden={hideLogin} onClick={fetchReservation} variant="primary">Hent reservation</Button>
            <Button hidden={!hideLogin || locked} onClick={updateReservation} variant="primary">Opdater Reservation</Button> {' '}
            <Button hidden={!hideLogin || locked} onClick={cancelReservation} variant="danger">Aflys Reservation</Button>
            

        </div>
    );

};

export default connect()(EditReservation);


